import type { AppInboxToastProps } from '@src/components/GlobalToasts/AppInboxToast';
import type { AppNotification } from '../AppNotificationsMonitorContainer';
import type { NotificationTransformerFn } from '../getNotificationRenderInfo';
import { OrderStatusNotificationToastContent } from './OrderStatusNotificationToastContent';
import { OrderStatusNotificationTransformer } from './OrderStatusNotificationTransformer';

// Mapping of notification types to their corresponding display information
export const notificationTypeToDisplayInfo: Record<
  AppNotification['Type'],
  {
    toastContent: React.ComponentType<AppInboxToastProps>;
    transform: NotificationTransformerFn;
  }
> = {
  OrderStatus: {
    toastContent: OrderStatusNotificationToastContent,
    transform: OrderStatusNotificationTransformer,
  },
};
